import { useContext } from 'react';
import { SurveyResultsFilterContext } from '../context';

export function useSurveyResultsFilter() {
	return useContext(SurveyResultsFilterContext);
}
